var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.giftcard)?_c('div',{staticClass:"extras"},[_vm._m(0),_c('GiftcardForm',{attrs:{"saving":_vm.saving,"giftcard":_vm.giftcard,"error":_vm.error},on:{"save":_vm.save,"resetError":function($event){_vm.error=null}}})],1):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breadcrumbs"},[_c('h2',[_vm._v("Edit")])])
}]

export { render, staticRenderFns }